import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { GreetingHeader } from './components/greeting-header/greeting-header';
import { StatsCards } from './components/stats-cards/stats-cards';
import { PerformanceChart } from './components/performance-chart/performance-chart';
import { SkillsChart } from './components/skills-chart/skills-chart';
import { AppLauncherGrid } from './components/app-launcher/app-launcher';
import { DashboardStore } from './data-access/dashboard.store';
import { CelotexBoard, CelotexStore } from '../celotex';
import { GuarnicaoCard } from '../../core/guarnicao/components/guarnicao-card/guarnicao-card';
import { GuarnicaoStore } from '../../core/guarnicao/services/guarnicao.store';
import { FeatureFlagService } from '../../core/feature-flags';

const POLL_INTERVAL_MS = 60_000;

@Component({
  selector: 'app-inicio',
  imports: [GreetingHeader, StatsCards, PerformanceChart, SkillsChart, AppLauncherGrid, MatIconModule, CelotexBoard, GuarnicaoCard],
  templateUrl: './inicio.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Inicio implements OnInit {
  protected readonly store = inject(DashboardStore);
  protected readonly celotexStore = inject(CelotexStore);
  protected readonly guarnicaoStore = inject(GuarnicaoStore);
  readonly flagService = inject(FeatureFlagService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.store.loadDashboard();
    this.celotexStore.carregar();
    this.guarnicaoStore.carregarInicial();

    interval(POLL_INTERVAL_MS)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (!document.hidden) {
          this.store.carregarSilencioso();
          this.celotexStore.recarregarSilencioso();
        }
      });
  }
}
